import {FC, ReactElement} from 'react';
import Box, { BoxProps } from './layouts/Box';
import Flex from './layouts/Flex';
import styled from '@emotion/styled';
import { pick } from '@styled-system/props';
import { variant } from 'styled-system';
import WithIcon from './layouts/WithIcon';
import theme from '../../theme';

interface HeaderContainerProps extends BoxProps {
  variant: HeaderProps['variant'];
}

const HeaderContainer = styled(Box)<HeaderContainerProps>(props => {
  const boxProps = pick(props);
  return [
    variant({
      variants: {
        page: {
          fontSize: 'l',
          lineHeight: 1.25,
          fontWeight: 'bold',
          ...boxProps
        },
        section: {
          fontSize: 'm',
          lineHeight: 1.5,
          paddingBottom: 'm',
          borderBottom: 'default',
          fontWeight: 'bold',
          ...boxProps
        }
      }
    })
  ];
});

HeaderContainer.defaultProps = {
  variant: 'section'
};

interface HeaderProps extends BoxProps {
  title: string | ReactElement;
  icon?: ReactElement;
  space?: keyof typeof theme.space;
  iconColor?: keyof typeof theme.colors;
  button?: ReactElement;
  variant?: 'page' | 'section';
}

const Header: FC<HeaderProps> = ({
  title = '',
  icon,
  space = 's',
  iconColor = 'primary',
  button,
  variant = 'section',
  children,
  ...boxProps
}) => (
  <HeaderContainer variant={variant} {...pick(boxProps)}>
    <Flex width="100%" justifyContent="space-between" alignItems="center">
      <WithIcon color={iconColor} space={space}>
        {icon}
        {title}
      </WithIcon>
      {button}
    </Flex>
    {children}
  </HeaderContainer>
);

export default Header;
